import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@chakra-ui/react';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay />
    <ModalContent dir="rtl">
      <ModalHeader textAlign="right">تأكيد الحذف</ModalHeader>
      <ModalBody textAlign="right">
        هل أنت متأكد أنك تريد حذف هذا العنصر؟ لا يمكن التراجع عن هذا الإجراء.
      </ModalBody>
      <ModalFooter justifyContent="flex-start">
        <Button colorScheme="red" ml={3} onClick={onConfirm}>
          حذف
        </Button>
        <Button variant="ghost" onClick={onClose}>
          إلغاء
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default DeleteConfirmationModal;


